import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { Icon, Tooltip } from "@blueprintjs/core";
import "./style.css";
function VeWarning(props) {
  const { message, tooltip, ...rest } = props;
  return /* @__PURE__ */ jsxs("div", { className: "veWarningMessage", ...rest, children: [
    /* @__PURE__ */ jsx(
      Tooltip,
      {
        position: "bottom",
        intent: "warning",
        popoverClassName: "bp3-popover-content-sizing",
        content: tooltip,
        children: /* @__PURE__ */ jsx(Icon, { size: 20, intent: "warning", icon: "warning-sign" })
      }
    ),
    message
  ] });
}
export default VeWarning;
